import { Button, Typography } from "@/common/styles/style";

interface ReportDownloadButtonProps {
  handleClick: () => void;
}
export default function CSVDownloadButton({
  handleClick,
}: ReportDownloadButtonProps) {
  return (
    <Button variant="contained" size="small" onClick={handleClick}>
      <Typography variant="button">帳票ダウンロード</Typography>
    </Button>
  );
}
